const STRATEGIES = [
  { name: 'Undercut by %', detail: 'Stay just below the median of your competitive set.' },
  { name: 'Target margin', detail: 'Price to your operator-level margin floor or target.' },
  { name: 'Last-minute', detail: 'Discount within a configurable window before charter start.' },
  { name: 'Early-bird', detail: 'Reward booking ahead of the season cutoff date.' },
  { name: 'Event surge', detail: 'Lift rates during regattas, holidays, and demand spikes.' },
];

export function LandingPricingStrategies() {
  return (
    <section id="dynamic-pricing" className="scroll-mt-20 border-t border-border py-32 md:py-40">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mb-12 max-w-3xl">
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.18em] text-muted-foreground">
            Dynamic pricing
          </p>
          <h2 className="mb-6 text-3xl font-semibold tracking-tight text-foreground md:text-4xl">
            A pricing strategy for every yacht, every season, every market state.
          </h2>
          <p className="text-base text-muted-foreground md:text-lg">
            Pick from proven strategies, or stack them per yacht, per season, per base. Sea Snag
            generates suggested rates daily, grounded in your competitive set&rsquo;s live state.
            Accept, edit, or override with one click.
          </p>
        </div>

        <div className="mb-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
          {STRATEGIES.map((strategy) => (
            <div key={strategy.name} className="rounded-lg border border-border bg-background p-4">
              <p className="font-mono text-[11px] uppercase tracking-wider text-muted-foreground">
                Strategy
              </p>
              <p className="mt-2 text-sm font-semibold text-foreground">{strategy.name}</p>
              <p className="mt-2 text-xs leading-relaxed text-muted-foreground">
                {strategy.detail}
              </p>
            </div>
          ))}
        </div>

        <DynamicPricingMock />
      </div>
    </section>
  );
}

function DynamicPricingMock() {
  const weeks = [
    { week: 'Jun 22', base: 3200, suggested: 3420, change: '+6.9%' },
    { week: 'Jun 29', base: 3400, suggested: 3680, change: '+8.2%' },
    { week: 'Jul 06', base: 3800, suggested: 4110, change: '+8.2%' },
    { week: 'Jul 13', base: 4100, suggested: 4520, change: '+10.2%' },
    { week: 'Jul 20', base: 4200, suggested: 4400, change: '+4.8%' },
    { week: 'Jul 27', base: 4200, suggested: 4060, change: '−3.3%' },
  ];
  return (
    <div className="rounded-lg border border-border bg-background p-6">
      <div className="mb-4 flex flex-wrap items-center gap-2">
        <span className="font-mono text-xs uppercase tracking-wider text-muted-foreground">
          Bavaria 46 · &ldquo;Adriatic Wind&rdquo;
        </span>
        <span className="rounded-full border border-border bg-muted/30 px-2.5 py-1 font-mono text-[11px] text-foreground">
          Undercut · 3% below set median
        </span>
        <span className="rounded-full border border-border bg-muted/30 px-2.5 py-1 font-mono text-[11px] text-foreground">
          Last-minute · &lt; 21 days
        </span>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
        {weeks.map((week) => (
          <div key={week.week} className="rounded-md border border-border p-4">
            <p className="font-mono text-xs uppercase tracking-wider text-muted-foreground">
              {week.week}
            </p>
            <p className="mt-3 font-mono text-2xl tabular-nums font-semibold text-foreground">
              €{week.suggested.toLocaleString()}
            </p>
            <p className="mt-1 font-mono text-xs tabular-nums text-muted-foreground">
              base €{week.base.toLocaleString()}
            </p>
            <p
              className={
                week.change.startsWith('−')
                  ? 'mt-2 font-mono text-xs tabular-nums text-rose-600 dark:text-rose-400'
                  : 'mt-2 font-mono text-xs tabular-nums text-emerald-600 dark:text-emerald-400'
              }
            >
              {week.change} vs base
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
